import * as managerCompanies from '@appStore/managers/actions/manager-companies.actions';
import * as managerRoles from '@appStore/managers/actions/manager-roles.actions';
import * as managerInvitations from '@appStore/managers/actions/manager-company-invitation.actions';
import * as managerCustomers from '@appStore/managers/actions/manager-customers.actions';
import * as managersTable from '@appStore/managers/actions/managers-table.actions';

export * from '@appStore/managers/actions/manager-companies.actions';
export * from '@appStore/managers/actions/manager-roles.actions';
export * from '@appStore/managers/actions/manager-company-invitation.actions';
export * from '@appStore/managers/actions/manager-customers.actions';
export * from '@appStore/managers/actions/managers-table.actions';

export const ActionTypes = {
  ...managerCompanies.ManagerCompaniesActionTypes,
  ...managerRoles.ManagerRolesActionTypes,
  ...managerInvitations.ManagerCompanyInvitationActionTypes,
  ...managerCustomers.ManagerCustomersActionTypes,
  ...managersTable.ManagersTableActionTypes
};

export type Actions = [

    | managerCompanies.ManagerCompaniesActions
    | managerRoles.ManagerRolesActions
    | managerInvitations.ManagerCompanyInvitationActions
    | managerCustomers.ManagerCustomersActions
    | managersTable.ManagersTableActions
];
